export default "mutation OptOutOfHomeClub{optOutOfHomeClub}"